export const categories = [
  { slug: 'love', name: '恋爱', icon: 'ri-heart-line', count: 128 },
  { slug: 'action', name: '热血动作', icon: 'ri-fire-line', count: 96 },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line', count: 87 },
  { slug: 'thriller', name: '悬疑惊悚', icon: 'ri-ghost-line', count: 64 },
  { slug: 'comedy', name: '轻松搞笑', icon: 'ri-emotion-laugh-line', count: 73 },
  { slug: 'drama', name: '都市剧情', icon: 'ri-building-line', count: 82 },
  { slug: 'bl', name: 'BL专区', icon: 'ri-star-line', count: 105 },
  { slug: 'historical', name: '古风穿越', icon: 'ri-ancient-gate-line', count: 45 },
];

export const categoryMap: Record<string, string> = {
  love: '恋爱',
  action: '热血动作',
  fantasy: '奇幻冒险',
  thriller: '悬疑惊悚',
  comedy: '轻松搞笑',
  drama: '都市剧情',
  bl: 'BL专区',
  historical: '古风穿越',
};